var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVk = function SvgVk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.053 0H0c.095 4.372 2.434 7 6.535 7h.23V4.498a3.836 3.836 0 0 1 1.958.813A3.475 3.475 0 0 1 9.872 7H12a5.434 5.434 0 0 0-1.14-2.064A5.896 5.896 0 0 0 8.919 3.49 5.545 5.545 0 0 0 10.62 2 5.08 5.08 0 0 0 11.548 0H9.616c-.422 1.387-1.666 2.649-2.85 2.768V0H4.832v4.849c-1.2-.28-2.715-1.64-2.78-4.849Z",
    fill: "#151515"
  })));
};
export default SvgVk;